module.exports = __webpack_public_path__ + "ce4c8db3eda99fd12c799cc3def054ec.svg";